import { render } from "./SubmissionsList.vue?vue&type=template&id=05d34156&scoped=true"
import script from "./SubmissionsList.vue?vue&type=script&lang=js"
export * from "./SubmissionsList.vue?vue&type=script&lang=js"

import "./SubmissionsList.vue?vue&type=style&index=0&id=05d34156&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d34156"]])

export default __exports__